/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getCustomerPortfoliosInfo} from '../api'

 export const useQueryGetCustomerPortfoliosInfo = createReactQueryHook('getCustomerPortfoliosInfo', getCustomerPortfoliosInfo)
